import { firebase, database } from "./firebase";
import { snapshot2List } from "./utils";

const contactTable = "contact";
const contactRef = database.ref(contactTable);

export function sendContact(contact) {
  contact = {
    ...contact,
    time: new Date().toISOString(),
  };
  const key = contactRef.push().key;
  // console.log('contact', contact)
  contactRef.child(key).set(contact);
}

// export const sendContact = firebase.functions().httpsCallable('createContact')

export function getContact() {
  return new Promise((success, fail) => {
    contactRef.orderByChild("time").once(
      "value",
      (snapshot) => {
        let list = snapshot2List(snapshot);
        list.reverse();
        success(list);
      },
      fail
    );
  });
}
